<template>
  <div v-show="isLoaded" class="mCRanking_container" v-observe-visibility="startAnimate">
    <!-- <img class="mCRanking_img" :src="banner" alt="Banner Ranking"> -->
    <!-- <img class="mCRanking_img_one" :class="{animate: animate}" :src="img" alt="Categoría 6ta"> -->
    <h1 class="mCRanking_title" :class="{animate: animate}">Ranking</h1>
    <div class="mCRanking_row" :class="{animate: animate}">
        <h2 class="mCRanking_subtitle">Categoría <span class="number">6</span><span class="p">ta</span> <br></h2>
        <h3 class="mCRanking_subtitle_one"><u>Varonil</u></h3>
        <div class="mCRanking_table">
            <table>
                <tbody id="tabla-usuarios">
                    <tr>
                        <th>POSICIÓN</th>
                        <th>NOMBRE Y APELLIDO</th>
                        <th>PUNTOS</th>
                    </tr>
                </tbody>
            </table>
        </div> 
    </div>
    <div class="mCRanking_row_two" :class="{animate: animate}">
        <h2 class="mCRanking_subtitle">Categoría <span class="number">5</span><span class="p">ta</span></h2>
        <h3 class="mCRanking_subtitle_one"><u>Varonil</u></h3>
        <div class="mCRanking_table">
            <table>
                <tbody id="tabla-usuariostwo">
                    <tr>
                        <th>POSICIÓN</th>
                        <th>NOMBRE Y APELLIDO</th>
                        <th>PUNTOS</th>
                    </tr>
                </tbody>
            </table>
        </div> 
    </div>
    <div class="mCRanking_row_thee" :class="{animate: animate}">
        <h2 class="mCRanking_subtitle">Categoría <span class="number">4</span><span class="p">ta</span></h2>
        <h3 class="mCRanking_subtitle_one"><u>Varonil</u></h3>
        <div class="mCRanking_table">
            <table>
                <tbody id="tabla-usuariosthee">
                    <tr>
                        <th>POSICIÓN</th>
                        <th>NOMBRE Y APELLIDO</th>
                        <th>PUNTOS</th>
                    </tr>
                </tbody>
            </table>
        </div> 
    </div>
    <div class="mCRanking_row_four" :class="{animate: animate}">
        <h2 class="mCRanking_subtitle">Categoría <span class="number">3</span><span class="p">ra</span></h2>
        <h3 class="mCRanking_subtitle_one"><u>Varonil</u></h3>
        <div class="mCRanking_table">
            <table>
                <tbody id="tabla-usuariosfour">
                    <tr>
                        <th>POSICIÓN</th>
                        <th>NOMBRE Y APELLIDO</th>
                        <th>PUNTOS</th>
                    </tr>
                </tbody>
            </table>
        </div> 
    </div>
    <div class="mCRanking_row_five" :class="{animate: animate}">
        <h2 class="mCRanking_subtitle">Categoría <span class="number">6</span><span class="p">ta</span></h2>
        <h3 class="mCRanking_subtitle_one"><u>Femenil</u></h3>
        <div class="mCRanking_table">
            <table>
                <tbody id="tabla-usuariosfive">
                    <tr>
                        <th>POSICIÓN</th>
                        <th>NOMBRE Y APELLIDO</th>
                        <th>PUNTOS</th>
                    </tr>
                </tbody>
            </table>
        </div> 
    </div>
    <div class="mCRanking_row_six" :class="{animate: animate}">
        <h2 class="mCRanking_subtitle">Categoría <span class="number">5</span><span class="p">ta</span></h2>
        <h3 class="mCRanking_subtitle_one"><u>Femenil</u></h3>
        <div class="mCRanking_table">
            <table>
                <tbody id="tabla-usuariossix">
                    <tr>
                        <th>POSICIÓN</th>
                        <th>NOMBRE Y APELLIDO</th>
                        <th>PUNTOS</th>
                    </tr>
                </tbody>
            </table>
        </div> 
    </div>
    <!-- <img class="mCRanking_img_two" :class="{animate: animate}" :src="img_two" alt="Categoría 5ta"> -->
    <!-- <img class="mCRanking_img_thee" :class="{animate: animate}" :src="img_thee" alt="Categoría 4ta"> -->
    <!-- <img class="mCRanking_img_four" :class="{animate: animate}" :src="img_four" alt="Categoría 3ra"> -->
    <!-- <img class="mCRanking_img_five" :class="{animate: animate}" :src="img_five" alt="Categoría 6ta femenil"> -->
    <!-- <img class="mCRanking_img_banner" :src="banner_two" alt="Banner Ranking"> -->
  </div>
</template>

<script>
import banner from "@/assets/ranking_one.png";
import banner_two from "@/assets/ranking_two.png";
import img from "@/assets/ranking_img_one.png";
import img_two from "@/assets/ranking_img_two.png";
import img_thee from "@/assets/ranking_img_thee.png";
import img_four from "@/assets/ranking_img_four.png";
import img_five from "@/assets/ranking_img_five.png";
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "CRanking",
    data() {
        return {
            banner,
            banner_two,
            img,
            img_two,
            img_thee,
            img_four,
            img_five,
            animate: false,
            isSafari: false,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {
        window.scrollTo(0,0)
        // Usuarios de categoria 6ta Varonil
        const usuarios = [
            { number: '1', name: 'JOSÉ LUIS GARZA MORALES', cant: '160' },
            { number: '2', name: 'ANDRÉS DOMENE', cant: '100' },
            { number: '3', name: 'DAVID MARCOS', cant: '100' },
            { number: '4', name: 'HÉCTOR HUGO GUTIÉRREZ ', cant: '100' },
            { number: '5', name: 'LUIS RONALDO ROCHA', cant: '100' },
            { number: '6', name: 'HERNESTO GARZA', cant: '80' },
            { number: '7', name: 'HÉCTOR VILLAREAL', cant: '80' },
            { number: '8', name: 'HERNÁN TREVIÑO', cant: '80' },
            { number: '9', name: 'FEDERICO MONTUFAR FLORES', cant: '80' },
            { number: '10', name: 'RAMIRO GONZÁLEZ ', cant: '60' },
            { number: '11', name: 'CRISTIAN ROSANI', cant: '60' },
            { number: '12', name: 'LEANDRO ESTRADA', cant: '60' },
            { number: '13', name: 'GONZALO ESTRADA', cant: '60' },
            { number: '14', name: 'MAURICIO GONZALEZ ', cant: '60' },
            { number: '15', name: 'FEDERICO MARCELO TREVIÑO ', cant: '60' },
            { number: '16', name: 'SERGIO SAIDE', cant: '60' },
            { number: '17', name: 'ARTURO JUSTINIANI', cant: '60' },
            { number: '18', name: 'LUIS AYALA ', cant: '60' },
            { number: '19', name: 'JOSÉ ALFREDO CADENA', cant: '60' },
            { number: '20', name: 'HÉCTOR ROBERTO NAVARRO', cant: '60' },
            { number: '21', name: 'RAFAEL ORDAZ VILLAREAL', cant: '60' },
            { number: '22', name: 'DIEGO MEDINA ACEVEZ', cant: '60' },
            { number: '23', name: 'DIEGO MANZUR ', cant: '40' },
            { number: '24', name: 'JAIME WEICHSEL', cant: '40' },
            { number: '25', name: 'MARIO GONZÁLEZ ', cant: '40' },
            { number: '26', name: 'JUAN GARZA', cant: '40' },
            { number: '27', name: 'PRISCILA CARDENAS ', cant: '40' },
            { number: '28', name: 'CRISTINA FAMA', cant: '40' },
            { number: '29', name: 'BORIS KARREN MARTINEZ', cant: '40' },
            { number: '30', name: 'DANIEL DEANDA YAÑEZ', cant: '40' },
            { number: '31', name: 'ALFREDO TREVIÑO', cant: '40' },
            { number: '32', name: 'SANTIAGO TREVIÑO', cant: '40' },
            { number: '33', name: 'FERNANDO URIBE GÓMEZ', cant: '40' },
            { number: '34', name: 'ANDRÉS URIBE GÓMEZ', cant: '40' },
            { number: '35', name: 'JORGUE VÁZQUEZ', cant: '20' },
            { number: '36', name: 'DANIELA ALCARAZ', cant: '20' },
            { number: '37', name: 'JUAN ALBA', cant: '20' },
            { number: '38', name: 'OSCAR GONZÁLEZ', cant: '20' },
            { number: '39', name: 'ALEJANDRO GARCÍA', cant: '20' },
            { number: '40', name: 'MIGUEL RENTERÍA', cant: '20' },
            { number: '41', name: 'MANUEL GÓMEZ', cant: '20' },
            { number: '42', name: 'RODRIGO CASTILLO', cant: '20' },
            { number: '43', name: 'RODRIGO ANAYA GONZÁLEZ', cant: '20' },
            { number: '44', name: 'ROBERTO CESAR NAVARRO', cant: '20' },
            { number: '45', name: 'RAMIRO HUMBERTO GARZA', cant: '20' },
            { number: '46', name: 'RAMIRO IGARTUA GARZA', cant: '20' },
            { number: '47', name: 'JUAN CARLOS CANTÚ SANTOS', cant: '20' },
            { number: '48', name: 'DIEGO TREVIÑO PIÑA', cant: '20' },
            { number: '49', name: 'HÉCTOR VILLAREAL ELIZONDO', cant: '20' },
            { number: '50', name: 'JORGE OMAR GARCÍA', cant: '20' },
        ];
        const tablaUsuarios = document.getElementById('tabla-usuarios');
        usuarios.forEach(usuario => {
            const fila = document.createElement('tr');
            fila.innerHTML = `
                <td><b>${usuario.number}</b></td>
                <td>${usuario.name}</td>
                <td><b>${usuario.cant}</b></td>
            `;
            tablaUsuarios.appendChild(fila);
        });
        // Usuarios de categoria 5ta Varonil
        const usuariostwo = [
            { number: '1', name: 'ALDO DECANINI GONZÁLEZ', cant: '120' },
            { number: '2', name: 'JOSÉ ÁNGEL QUINTANA CASTILLO', cant: '120' },
            { number: '3', name: 'ROBERTO GUTIÉRREZ', cant: '100' },
            { number: '4', name: 'DIEGO DÍAZ', cant: '100' },
            { number: '5', name: 'DANIEL DEL VALLE', cant: '100' },
            { number: '6', name: 'PATRICIO ALEJANDRO', cant: '100' },
            { number: '7', name: 'CESAR VILLASANA', cant: '100' },
            { number: '8', name: 'RAÚL CANO', cant: '100' },
            { number: '9', name: 'LUIS GARCÍA', cant: '80' },
            { number: '10', name: 'JUAN GARCÍA', cant: '80' },
            { number: '11', name: 'ALDO BORJAS', cant: '80' },
            { number: '12', name: 'RAÚL PORRAS', cant: '60' },
            { number: '13', name: 'ABELARDO RODRÍGUEZ', cant: '60' },
            { number: '14', name: 'MIGUEL GONZÁLEZ', cant: '60' },
            { number: '15', name: 'PATRICIO SÁNCHEZ', cant: '60' },
            { number: '16', name: 'LÁZARO CASAS', cant: '60' },
            { number: '17', name: 'FERNANDO TILERIA', cant: '60' },
            { number: '18', name: 'MAURICIO TATTERFIELD', cant: '60' },
            { number: '19', name: 'MAURICIO ROSSI', cant: '60' },
            { number: '20', name: 'MARTÍN DODERO', cant: '60' },
            { number: '21', name: 'ROGELIO GALLEGO', cant: '40' },
            { number: '22', name: 'HUGO ALMAGUER', cant: '40' },
            { number: '23', name: 'RODRIGO CASTILLO', cant: '40' },
            { number: '24', name: 'ADRIÁN BARRERA', cant: '40' },
            { number: '25', name: 'MAURICIO GONZÁLEZ', cant: '40' },
            { number: '26', name: 'GERARDO CANAVATTI', cant: '40' },
            { number: '27', name: 'GERARDO BELTRÁN', cant: '40' },
            { number: '28', name: 'JORGE SÁNCHEZ', cant: '40' },
            { number: '29', name: 'ANDRÉS MELÉNDEZ TORRES', cant: '40' },
            { number: '30', name: 'DANIEL SALAZAR', cant: '20' },
            { number: '31', name: 'ETHAN TORRESILLA', cant: '20' },
            { number: '32', name: 'GUILLERMO VILLASA', cant: '20' },
            { number: '33', name: 'ALEJANDRO PADILLA', cant: '20' },
            { number: '34', name: 'DAVID LEAL', cant: '20' },
            { number: '35', name: 'MIGUEL SOTELDO', cant: '20' },
            { number: '36', name: 'MARCELO LAVIN', cant: '20' },
            { number: '37', name: 'ALBERTO GARZA', cant: '20' },
            { number: '38', name: 'ANDRES PONS', cant: '20' },
            { number: '39', name: 'MOISES ARECCHIGA', cant: '20' },
            { number: '40', name: 'ANDRÉS ALBERTO MARTÍNEZ', cant: '20' },
            { number: '41', name: 'MARCELO GONZÁLEZ VELA', cant: '20' },
            { number: '42', name: 'CARLOS SANCHEZ', cant: '20' },
            { number: '43', name: 'IVÁN ESPINOZA', cant: '20' },
            { number: '44', name: 'RODOLFO KIRCHNER RODRÍGUEZ', cant: '20' },
            { number: '45', name: 'MARCELO KIRCHNER RODRÍGUEZ', cant: '20' },
            { number: '46', name: 'HÉCTOR GÓMEZ CABALLOS', cant: '20' },
            { number: '47', name: 'JAVIER GUTIÉRREZ', cant: '20' },
            { number: '48', name: 'ERICK PRADA', cant: '20' },
            { number: '49', name: 'JESÚS MAURICIO RODRÍGUEZ', cant: '20' },
            { number: '50', name: 'MIGUEL JOSE ÁLVAREZ GATICA', cant: '20' },
            { number: '51', name: 'RAFAEL MEJIA', cant: '20' },
            { number: '52', name: 'NIDOL ISSA', cant: '20' }
        ];
        const tablaUsuariostwo = document.getElementById('tabla-usuariostwo');
        usuariostwo.forEach(usuariostwo => {
            const fila = document.createElement('tr');
            fila.innerHTML = `
                <td><b>${usuariostwo.number}</b></td>
                <td>${usuariostwo.name}</td>
                <td><b>${usuariostwo.cant}</b></td>
            `;
            tablaUsuariostwo.appendChild(fila);
        });
        // Usuarios de categoria 4ta Varonil
        const usuariosthee = [
            { number: '1', name: 'PATRICIO RUIZ', cant: '120' },
            { number: '2', name: 'RAÚL CORTES', cant: '120' },
            { number: '3', name: 'JUAN CARLOS SAINZ', cant: '100' },
            { number: '4', name: 'ROGELIO TOUCHER', cant: '100' },
            { number: '5', name: 'JOSÉ FERNÁNDEZ', cant: '100' },
            { number: '6', name: 'RICARDO LECHUGA HUERTA', cant: '100' },
            { number: '7', name: 'CESAR AUSTO ALVARAREZ', cant: '100' },
            { number: '8', name: 'PATRICIO LUNA', cant: '80' },
            { number: '9', name: 'JORGUE SÁNCHEZ', cant: '80' },
            { number: '10', name: 'ALEJANDRO SÁNCHEZ', cant: '80' },
            { number: '11', name: 'PAUL TORRES', cant: '80' },
            { number: '12', name: 'JAVIER JIMÉNEZ', cant: '80' },
            { number: '13', name: 'LUCA CECHINI', cant: '60' },
            { number: '14', name: 'FERNANDO PADILLA', cant: '60' },
            { number: '15', name: 'PABLO LEMARROY', cant: '60' },
            { number: '16', name: 'ANDRÉS MEDALLIN', cant: '60' },
            { number: '17', name: 'CESAR JARERO', cant: '60' },
            { number: '18', name: 'RICARDO RODRÍGUEZ', cant: '60' },
            { number: '19', name: 'FRANCISCO MUÑOZ', cant: '40' },
            { number: '20', name: 'RODRIGO LUJÁN', cant: '40' },
            { number: '21', name: 'SEBASTIÁN GARZA', cant: '40' },
            { number: '22', name: 'GERARDO GARZA', cant: '40' },
            { number: '23', name: 'ADRIAN TOBON', cant: '40' },
            { number: '24', name: 'HÉCTOR MANUEL GIL', cant: '40' },
            { number: '25', name: 'ANDRÉS ELIZONDO ALVARES', cant: '40' },
            { number: '26', name: 'JOSÉ CARLOS RODRÍGUEZ', cant: '40' },
            { number: '27', name: 'MARIO JAVIER RODRÍGUEZ', cant: '40' },
            { number: '28', name: 'MANUEL SOTELDO', cant: '40' },
            { number: '29', name: 'MAX RAMOS', cant: '40' },
            { number: '30', name: 'JOSÉ LUIS DOMÍNGUEZ', cant: '40' },
            { number: '31', name: 'CARLOS JARQUIN', cant: '40' },
            { number: '32', name: 'CARLOS GONZÁLEZ', cant: '20' },
            { number: '33', name: 'MAICO PEREIRA', cant: '20' },
            { number: '34', name: 'FRANCISCO RUIZ', cant: '20' },
            { number: '35', name: 'GERARDO VALDEZ', cant: '20' },
            { number: '36', name: 'MAURICIO VALDEZ', cant: '20' },
            { number: '37', name: 'ALFREDO TREVIÑO', cant: '20' },
            { number: '38', name: 'ROLANDO CASTRO', cant: '20' },
            { number: '39', name: 'DIEGO SALAZAR', cant: '20' },
            { number: '40', name: 'ANDRES ESPERANZA', cant: '20' },
            { number: '41', name: 'ARMANDO DE LA ROSA', cant: '20' },
            { number: '42', name: 'JOSÉ VILLAREAL', cant: '20' },
            { number: '43', name: 'ANDRÉS GONZÁLEZ', cant: '20' },
            { number: '44', name: 'MANUEL FLORES GONZÁLEZ', cant: '20' },
            { number: '45', name: 'MARIO PEDRO ARENA', cant: '20' },
            { number: '46', name: 'RODRIGO MARTÍNEZ', cant: '20' },
            { number: '47', name: 'VÍCTOR DEL BOSQUE', cant: '20' },
            { number: '48', name: 'ALEJANDRO SOTELDO', cant: '20' },
            { number: '49', name: 'RAFAEL LIZARRAGA', cant: '20' },
            { number: '50', name: 'DIEGO VALDES', cant: '20' },
            { number: '51', name: 'ALEJANDRO FLORES CANTU', cant: '20' },
            { number: '52', name: 'JORGE MARTÍNEZ ROMERO', cant: '20' },
            { number: '53', name: 'PATRICIO VELA', cant: '20' }
        ];
        const tablaUsuariosthee = document.getElementById('tabla-usuariosthee');
        usuariosthee.forEach(usuariosthee => {
            const fila = document.createElement('tr');
            fila.innerHTML = `
                <td><b>${usuariosthee.number}</b></td>
                <td>${usuariosthee.name}</td>
                <td><b>${usuariosthee.cant}</b></td>
            `;
            tablaUsuariosthee.appendChild(fila);
        });
        // Usuarios de categoria 3ra Varonil
        const usuariosfour = [
            { number: '1', name: 'SANTIAGO GUERRA', cant: '180' },
            { number: '2', name: 'JUAN RODRÍGUEZ', cant: '180' },
            { number: '3', name: 'MICHAEL HEGST', cant: '140' },
            { number: '4', name: 'CRISTIAN LONGORIA', cant: '140' },
            { number: '5', name: 'RAÚL CANO', cant: '100' },
            { number: '6', name: 'MATÍAS CEREZO', cant: '100' },
            { number: '7', name: 'FABIÁN PEÑA', cant: '70' },
            { number: '8', name: 'FABIÁN PEÑA', cant: '70' },
            { number: '9', name: 'JORGUE GONZÁLEZ', cant: '60' },
            { number: '10', name: 'JESÚS GARCÍA', cant: '60' },
            { number: '11', name: 'GONZALO ESTRADA', cant: '60' },
            { number: '12', name: 'FEDERICO COLYE', cant: '60' },
            { number: '13', name: 'RAÚL TREJO', cant: '20' },
            { number: '14', name: 'JUAN LORETO', cant: '20' },
            { number: '15', name: 'GERARDO GONZÁLEZ', cant: '10' },
            { number: '16', name: 'FRANCISCO DE LA GARZA', cant: '10' },
            { number: '17', name: 'VIVIANA SALAZAR', cant: '10' },
            { number: '18', name: 'JORGUE FLORES', cant: '10' },
            { number: '19', name: 'JULIAN AGUERO', cant: '10' },
            { number: '20', name: 'AGUSTINA GARECA', cant: '10' },
            { number: '21', name: 'ARTURO CAMACHO', cant: '10' },
            { number: '22', name: 'FABRICIO PEÑA', cant: '10' }
        ];
        const tablaUsuariosfour = document.getElementById('tabla-usuariosfour');
        usuariosfour.forEach(usuariosfour => {
            const fila = document.createElement('tr');
            fila.innerHTML = `
                <td><b>${usuariosfour.number}</b></td>
                <td>${usuariosfour.name}</td>
                <td><b>${usuariosfour.cant}</b></td>
            `;
            tablaUsuariosfour.appendChild(fila);
        });
         // Usuarios de categoria 6ta Femenil
        const usuariosfive = [
            { number: '1', name: 'LORETTA SÁNCHEZ', cant: '100' },
            { number: '2', name: 'VALERIA GARZA', cant: '100' },
            { number: '3', name: 'ABRIL SÁNCHEZ', cant: '100' },
            { number: '4', name: 'ANA LAURA RODRÍGUEZ', cant: '100' },
            { number: '5', name: 'RAQUEL KLINK GONZALEZ', cant: '100' },
            { number: '6', name: 'FERNANDA GONZÁLEZ', cant: '80' },
            { number: '7', name: 'BARBARA RUIZ', cant: '80' },
            { number: '8', name: 'FRANCIELA COINDREAU', cant: '80' },
            { number: '9', name: 'VIOLETA GARZA', cant: '80' },
            { number: '10', name: 'NANCY MORALES', cant: '60' },
            { number: '11', name: 'REGINA SAUCEDO', cant: '60' },
            { number: '12', name: 'SIMARU MUJICA', cant: '60' },
            { number: '13', name: 'PAULINA MARROQUÍN', cant: '60' },
            { number: '14', name: 'JAQUELINE SÁNCHEZ', cant: '60' },
            { number: '15', name: 'YADIRA BUSTAMANTE TREVIÑO', cant: '60' },
            { number: '16', name: 'MAYELA GARCÍA OSTIGUIN', cant: '60' },
            { number: '17', name: 'PATRICIA EMILIA', cant: '40' },
            { number: '18', name: 'SISSY KAREM', cant: '40' },
            { number: '19', name: 'CECILIA MEDERO', cant: '40' },
            { number: '20', name: 'SUSANA GUTIÉRREZ', cant: '10' },
            { number: '21', name: 'BARBARA GARDA', cant: '10' },
            { number: '22', name: 'LESLI CHÁVEZ', cant: '10' },
            { number: '23', name: 'MARU RENDÓN', cant: '10' },
            { number: '24', name: 'KARLA GARCÍA', cant: '10' },
            { number: '25', name: 'DANIELA LOZANO', cant: '10' },
            { number: '26', name: 'PAOLA MOSQUEDA', cant: '10' },
            { number: '27', name: 'MARU FERNÁNDEZ', cant: '10' },
            { number: '28', name: 'PAMELA SIFUNETES', cant: '10' },
            { number: '29', name: 'ANDREA ROBAINA', cant: '10' },
            { number: '30', name: 'ELENE GUTIÉRREZ MORENO', cant: '10' },
            { number: '31', name: 'DANIELA RIOS CANTU', cant: '10' },
            { number: '32', name: 'XIMENA HERMANDEZ MORALES', cant: '10' },
            { number: '33', name: 'KARLA HIDALGO', cant: '10' },
            { number: '34', name: 'NIDIA DE ANDA', cant: '10' },
            { number: '35', name: 'CARMEN VÁZQUEZ', cant: '10' }
        ];
        const tablaUsuariosfive = document.getElementById('tabla-usuariosfive');
        usuariosfive.forEach(usuariosfive => {
            const fila = document.createElement('tr');
            fila.innerHTML = `
                <td><b>${usuariosfive.number}</b></td>
                <td>${usuariosfive.name}</td>
                <td><b>${usuariosfive.cant}</b></td>
            `;
            tablaUsuariosfive.appendChild(fila);
        });
        // Usuarios de categoria 5ta Femenil
        const usuariossix = [
            { number: '1', name: 'NINFA ELIZONDO', cant: '160' },
            { number: '2', name: 'ANA PAULA ELIZONDO', cant: '160' },
            { number: '3', name: 'KATY GUERRA', cant: '100' },
            { number: '4', name: 'ALEJANDRA GAMBOA', cant: '100' },
            { number: '5', name: 'MARTHA VILLAREAL', cant: '80' },
            { number: '6', name: 'MAYELA GONZÁLEZ', cant: '80' },
            { number: '7', name: 'SOFÍA GARZA', cant: '80' },
            { number: '8', name: 'ALEJANDRA LEAL FARIA', cant: '80' },
            { number: '9', name: 'CLAUDIA DE OLIVERA', cant: '60' },
            { number: '10', name: 'KARLA VILLAFUERTE', cant: '60' },
            { number: '11', name: 'ANDREA PEDROSO', cant: '60' },
            { number: '12', name: 'PATRICIA LOZANO', cant: '60' },
            { number: '13', name: 'ADELA OLVERA', cant: '50' },
            { number: '14', name: 'DULCE GANDARA', cant: '50' },
            { number: '15', name: 'CYNTHIA SÁNCHEZ', cant: '40' },
            { number: '16', name: 'DANIELA RENOVALES', cant: '40' },
            { number: '17', name: 'CLAUDIA RODRÍGUEZ', cant: '40' },
            { number: '18', name: 'MARIANGELA VALDERRAMA', cant: '40' },
            { number: '19', name: 'CLAUDIA MORALES ', cant: '20' },
            { number: '20', name: 'MARLÉN LARA', cant: '10' },
            { number: '21', name: 'LEONOR SADA', cant: '10' },
            { number: '22', name: 'RUTH NASSAR', cant: '10' },
            { number: '23', name: 'NANCY MORALES GALVÁN', cant: '10' },
            { number: '24', name: 'FRANCIELLA PETROCCHI', cant: '10' },
            { number: '25', name: 'REYNA ROBLES', cant: '10' }
        ];
        const tablaUsuariossix = document.getElementById('tabla-usuariossix');
        usuariossix.forEach(usuariossix => {
            const fila = document.createElement('tr');
            fila.innerHTML = `
                <td><b>${usuariossix.number}</b></td>
                <td>${usuariossix.name}</td>
                <td><b>${usuariossix.cant}</b></td>
            `;
            tablaUsuariossix.appendChild(fila);
        });
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/CRanking.scss";
</style>

<style lang="scss">
table {
    border: solid 1px white;
    font-size: 2.8vw;
    text-align: center;
    @media screen and (max-width: 768px) {
        font-size: 3.5vw;
    }
}
th, td {
    padding: 1vw 2vw 1vw 2vw !important;
    border: 1px solid white;   
}
</style>